import React, { useState } from 'react';
import { Box, Typography, Paper, IconButton, Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const ViolationPanel = ({ violations = [] }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const getSeverityColor = (severity) => {
    if (!severity) return 'info.main';
    switch (severity.toLowerCase()) {
      case 'high':
        return 'error.main';
      case 'medium':
        return 'warning.main';
      case 'low':
        return 'info.main';
      default:
        return 'text.secondary';
    }
  };

  return (
    <Paper elevation={1} sx={{ width: '100%' }}>
      <Box 
        sx={{ 
          p: 2, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          cursor: 'pointer',
          bgcolor: 'background.paper'
        }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Typography variant="h6">
          Violations ({violations.length})
        </Typography>
        <IconButton size="small">
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={isExpanded}>
        <Box sx={{ p: 2, maxHeight: '400px', overflow: 'auto' }}>
          {violations.length === 0 ? (
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
              No violations detected
            </Typography>
          ) : (
            violations.map((violation, index) => (
              <Paper 
                key={`${violation.type}-${violation.timestamp}-${index}`}
                elevation={0}
                sx={{ 
                  p: 2,
                  mb: 1,
                  borderLeft: `4px solid`,
                  borderColor: getSeverityColor(violation.severity || 'low'),
                  bgcolor: 'background.default'
                }}
              >
                <Typography variant="body2" color="text.secondary">
                  {new Date(violation.timestamp).toLocaleTimeString()}
                </Typography>
                <Typography variant="body1" sx={{ mt: 0.5 }}>
                  {violation.type.replace(/_/g, ' ').toUpperCase()}
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: getSeverityColor(violation.severity || 'low'),
                    mt: 0.5,
                    textTransform: 'capitalize'
                  }}
                >
                  {(violation.severity || 'low')} Severity
                </Typography>
              </Paper>
            ))
          )}
        </Box>
      </Collapse>
    </Paper>
  );
};

export default ViolationPanel; 